import { ShadingMode, OutlineMode, CullingMode } from "flavr-common";
import { DoubleSide, BackSide, FrontSide, ShaderMaterial } from "three";
import { GLOBAL_UNIFORMS } from "../../shader/GlobalUniforms";
//  glslify is used for including GLSL shader code
const glslify = require("glslify");
const VERTEX_SHADER = require("./instance.vert");
const FRAGMENT_SHADER = require("./instance.frag");
const DEPTH_VERTEX_SHADER = require("./instance.depth.vert");
const DEPTH_FRAGMENT_SHADER = require("./instance.depth.frag");
export const INSTANCE_VERTEX_SHADER = VERTEX_SHADER && glslify(VERTEX_SHADER);
export const INSTANCE_FRAGMENT_SHADER = FRAGMENT_SHADER && glslify(FRAGMENT_SHADER);
export const INSTANCE_DEPTH_VERTEX_SHADER = DEPTH_VERTEX_SHADER && glslify(DEPTH_VERTEX_SHADER);
export const INSTANCE_DEPTH_FRAGMENT_SHADER = DEPTH_FRAGMENT_SHADER && glslify(DEPTH_FRAGMENT_SHADER);
export function createGeometryMaterial(defines, uniforms, properties, wireframe) {
    const materialOptions = {
        defines: defines,
        uniforms: uniforms,
        vertexShader: INSTANCE_VERTEX_SHADER,
        fragmentShader: INSTANCE_FRAGMENT_SHADER,
        wireframe: wireframe
    };
    configureShaderMaterialParametersForShadingMode(materialOptions, properties.shading);
    configureShaderMaterialParametersForOutlineMode(materialOptions, properties.outline || 0);
    configureShaderMaterialParametersForCullingMode(materialOptions, properties.cull || 0);
    const material = new ShaderMaterial(materialOptions);
    material.shadowSide = BackSide;
    if (properties.shading === ShadingMode.TransparentGrid) {
        material.transparent = true;
        material.opacity = 0.1;
        material.uniforms.map = GLOBAL_UNIFORMS.gridTexture;
        material.depthWrite = false;
    }
    return material;
}
export function configureShaderMaterialParametersForShadingMode(materialOptions, shadingMode) {
    var _a;
    const defines = (_a = materialOptions.defines) !== null && _a !== void 0 ? _a : (materialOptions.defines = {});
    switch (shadingMode) {
        case ShadingMode.PhongWithShadows:
            defines.USE_SHADOWMAP = "";
            defines.SHADOWMAP_TYPE_PCF_SOFT = "";
            defines.USE_LIGHTS = "";
            materialOptions.lights = true;
            break;
        case ShadingMode.Phong:
            defines.USE_LIGHTS = "";
            materialOptions.lights = true;
            break;
        case ShadingMode.Simple:
            defines.USE_SIMPLE_SHADING = "";
            materialOptions.lights = false;
            break;
        case ShadingMode.TransparentGrid:
            defines.USE_TRANSPARENT_GRID = "";
            materialOptions.lights = false;
            break;
        case ShadingMode.Unlit:
            materialOptions.lights = false;
            break;
    }
}
export function configureShaderMaterialParametersForOutlineMode(materialOptions, outlineMode) {
    var _a;
    const defines = (_a = materialOptions.defines) !== null && _a !== void 0 ? _a : (materialOptions.defines = {});
    switch (outlineMode) {
        case OutlineMode.Wavy:
            defines.USE_NOISE = "";
            defines.USE_WIREFRAMES = "";
            break;
        case OutlineMode.Straight:
            defines.USE_WIREFRAMES = "";
            break;
    }
}
export function configureShaderMaterialParametersForCullingMode(materialOptions, cullingMode) {
    var _a;
    const defines = (_a = materialOptions.defines) !== null && _a !== void 0 ? _a : (materialOptions.defines = {});
    switch (cullingMode) {
        case CullingMode.None:
            materialOptions.side = DoubleSide;
            break;
        case CullingMode.Front:
            defines.INVERT_NORMALS = "";
            materialOptions.side = BackSide;
            break;
        case CullingMode.Back:
            materialOptions.side = FrontSide;
            break;
    }
}
